import type { UserDataResponse } from '@/features/account/api/fetch-user-account';
import { accountQueryKeys } from '@/features/account/config/account-query-keys';
import { mainFirebaseApp } from '@/lib/firebase-init';
import { queryClient } from '@/providers/react-query/query-client';
import type { Context, Plugin } from '@segment/analytics-next';
import { getAuth } from 'firebase/auth';

/**
 * Docs for context:
 * https://segment.com/docs/connections/spec/common/#context
 */
function applyGroupIdToContext(ctx: Context) {
  const auth = getAuth(mainFirebaseApp);

  const cachedUserData = queryClient.getQueryData<UserDataResponse | undefined>(
    accountQueryKeys.userAccount(auth.currentUser?.uid ?? '')
  );

  ctx.event.groupId = cachedUserData?.orgid;

  if (ctx.event?.context) ctx.event.context.groupId = cachedUserData?.orgid;

  return ctx;
}

/**
 * Docs for plugins:
 * https://github.com/segmentio/analytics-next/tree/master/packages/browser#-plugins
 */
export const appendGroupIdPlugin: Plugin = {
  name: 'Append Group ID To Context',
  type: 'before',
  version: '1.0.0',

  isLoaded: () => true,
  load: () => Promise.resolve(),

  page: applyGroupIdToContext,
  track: applyGroupIdToContext,
};
